@if (basket.totals) {
  <section1 sectionIcon="basket"
    [sectionTitle]="title |translate"
    >
    @if (isSamples) {
      <div
        sectionBody
        class="flex flex-bottom flex-justify-between col-1 w-12">
        <div class="w-9 p2 col-11 p-l-9">
          {{samplesSelected}}&nbsp;{{(samplesSelected > 1 ? 'samples' : 'sample') | translate}}&nbsp;{{'selected' |
          translate}}
        </div>
      </div>
    }
    @if (!isSamples) {
      <checkout-expandable showCopy="Show"
        sectionBody>
        <div expandableTitle>
          <div>
            {{ 'Order total' | translate}} ({{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty
            }}):
            <price class="block-s"
              [value]="basket.totals?.grand_total || 0"
            [precision]="2"></price>
          </div>
          @if (displayShipping) {
            <p class="m-t-1"
              >{{'Delivery' | translate}}:&nbsp;@if (!selfCollect) {
              <price
                [value]="shippingPrice"
                [useFreeLabel]="true"
              [precision]="2"></price>
              }@if (selfCollect) {
              <span>{{'Collection' | translate}}</span>
            }
          </p>
        }
      </div>
      <div expandableBody>
        @for (item of basket.items; track itemTrackFn($index, item); let last = $last) {
          <basket-view-item class="block p-b m-t"
                            [class.b-b]="!last"
                            [item]="item"
                            [lock]="lock">
          </basket-view-item>
        }
        <basket-view-totals class="block m-t m-t-9-s m-t-9-m"></basket-view-totals>
      </div>
    </checkout-expandable>
  }
</section1>
}
